import React, { useState } from 'react';
import { Form, Button, Input, InputNumber, Typography } from 'antd';
import { LOW_BALANCE_ALERT_PRESETS, LOW_BALANCE_ALERT_DEFAULT } from 'constants/wallet';
import { AMPLITUDE_WALLET_PROPERTY_VALUES } from 'constants/amplitude';
import useTranslation from 'utils/hooks/useTranslation';
import { formatPresetAmount } from './helper';

import styles from './style.module.scss';

const { inputMethod: INPUT_METHODS } = AMPLITUDE_WALLET_PROPERTY_VALUES;

// `onAmountSelected({ amount, inputMethod })` reports a chosen preset, or a typed amount once the
// field loses focus (not per keystroke).
const LowBalanceAlert = ({ currencySymbol, form, onAmountSelected }) => {
  const { translateText } = useTranslation();
  const [selectedPreset, setSelectedPreset] = useState(LOW_BALANCE_ALERT_DEFAULT);

  const handlePresetClick = amount => {
    setSelectedPreset(amount);
    form.setFieldsValue({ lowBalanceOtherAmount: null, lowBalanceAlertAmount: amount });
    onAmountSelected?.({ amount, inputMethod: INPUT_METHODS.preset });
  };

  const handleOtherAmountBlur = () => {
    const value = form.getFieldValue('lowBalanceOtherAmount');
    if (value !== null && value !== undefined && value !== '') {
      onAmountSelected?.({ amount: Number(value), inputMethod: INPUT_METHODS.custom });
    }
  };

  const handleOtherAmountChange = value => {
    if (value !== null && value !== undefined && value !== '') {
      setSelectedPreset(null);
      form.setFieldsValue({ lowBalanceAlertAmount: value });
    } else {
      setSelectedPreset(LOW_BALANCE_ALERT_DEFAULT);
      form.setFieldsValue({ lowBalanceAlertAmount: LOW_BALANCE_ALERT_DEFAULT });
    }
  };

  return (
    <div className={styles.lowBalanceAlert}>
      <Typography.Title level={5} className={styles.sectionTitle}>
        {translateText('corporateAccounts.wallet.create.lowBalanceAlert.title')}
      </Typography.Title>
      <Typography.Paragraph className={styles.sectionDescription}>
        {translateText('corporateAccounts.wallet.create.lowBalanceAlert.description')}
      </Typography.Paragraph>
      <div className={styles.lowBalancePresets}>
        {LOW_BALANCE_ALERT_PRESETS.map(amount => (
          <Button
            key={amount}
            className={
              selectedPreset === amount
                ? `${styles.presetButton} ${styles.presetSelected}`
                : styles.presetButton
            }
            data-testid={`lowBalancePreset-${amount}`}
            onClick={() => handlePresetClick(amount)}
          >
            {formatPresetAmount(amount, currencySymbol)}
          </Button>
        ))}
        <Form.Item name="lowBalanceOtherAmount" noStyle>
          <InputNumber
            min={0}
            controls={false}
            placeholder={translateText(
              'corporateAccounts.wallet.create.lowBalanceAlert.otherAmount',
            )}
            className={styles.otherAmountInput}
            data-testid="lowBalanceOtherAmount"
            onChange={handleOtherAmountChange}
            onBlur={handleOtherAmountBlur}
          />
        </Form.Item>
        <Form.Item name="lowBalanceAlertAmount" initialValue={LOW_BALANCE_ALERT_DEFAULT} hidden>
          <Input type="hidden" />
        </Form.Item>
      </div>
    </div>
  );
};

export default LowBalanceAlert;
